<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <div
        style="width: 80%;margin: 0 auto;margin-top: 20px;margin-bottom: 20px"
      >
        <el-form
          ref="form"
          :model="form"
          label-width="160px"
          class="demo-ruleForm"
        >
          <p>自动化汇总</p>
          <el-form-item label="商品数量/波次：" prop="order_goods_num">
            <el-input
              v-model="form.auto_min"
              type="number"
              style="width: 25%;float: left"
              disabled
            ></el-input
            >~
            <el-input
              v-model="form.auto_max"
              type="number"
              style="width: 25%;"
              @change="set_many_nin"
            ></el-input>
          </el-form-item>
          <el-form-item label="波次汇总数量 ：" prop="summary_num">
            <el-input
              v-model="form.auto_num"
              type="number"
              style="width: 50%"
            ></el-input>
          </el-form-item>

          <p>多件多波汇总</p>
          <el-form-item label="商品数量/波次：" prop="order_goods_num">
            <el-input
              v-model="form.many_min"
              type="number"
              style="width: 25%;float: left"
              disabled
            ></el-input
            >~
            <el-input
              v-model="form.many_max"
              type="number"
              style="width: 25%;"
            ></el-input>
          </el-form-item>
          <el-form-item label="波次汇总数量 ：" prop="summary_num">
            <el-input
              v-model="form.many_num"
              type="number"
              style="width: 50%"
            ></el-input>
          </el-form-item>

          <p>提前汇总设置</p>
          <el-form-item label="波次数量 ：" prop="temp_summary_num">
            <el-input
              v-model="form.temp_summary_num"
              type="number"
              style="width: 50%"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row> </el-row>
  </div>
</template>

<script>
import Global_ from "../../components/Global";
import HeaderTabs from "./components/HeaderTabs";
export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      form: {
        auto_min: 2,
        auto_max: "",
        auto_num: "",
        many_min: 2,
        many_max: "",
        many_num: "",
        temp_summary_num: 0,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/SummarySetting",
      filterFold: false,
      supplyData: null,
      origin: Global_.origin,
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    set_many_nin(value) {
      this.form.many_min = parseInt(value) + 1;
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          if (JSON.stringify(res.data.data) != "{}") {
            this.form = res.data.data;
          }
        }
      });
    },
    onSubmit() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/SummarySetting.vue